import styled from 'styled-components';

interface StyledWeatherCardProps {
  $canvasHeight: number;
}

export const StyledWeatherCard = styled.div<StyledWeatherCardProps>`
  .graph-lists {
    position: relative;

    > canvas {
      width: 100%;
      height: ${({ $canvasHeight }) => $canvasHeight}px;
    }
  }
`;
